<main>
<router-outlet>
</router-outlet>
</main>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/app.component.html